import HttpService from 'ui-home/src/misc/HttpService/HttpService';
import { setJitaEnabledAccount } from 'ui-common/src/utils/LoginActions';
import { removeMenuById } from '../utils/removeMenuByID/removeMenuByID';

const AGENT_MANAGEMENT_NAV = {
  id: 'manage-agentic-identities',
  subMenu: [
    { id: 'agents', link: '/agent' },
    { id: 'service-identity', link: '/agent/service-identity' },
  ],
};

const MY_ACCESS_AGENT_NAV = [
  { id: 'ai-agent-requests', link: '/agent/request' },
  { id: 'ai-my-agentic-identities', link: '/agent/user' },
];

/**
 * Injects the "Manage Agentic Identities" parent menu into the "home" section,
 * right before "user-management". When isAgentRequestEnabled, also appends
 * agent request/identity items to the existing "my-access" submenu.
 */
function injectAgentManagementNav(topLevel, { isAgentRequestEnabled } = {}) {
  if (!topLevel || !Array.isArray(topLevel)) return topLevel || [];

  const homeIndex = topLevel.findIndex((menu) => menu.id === 'home');
  if (homeIndex === -1 || !topLevel[homeIndex].subMenu) return topLevel;

  const subMenu = topLevel[homeIndex].subMenu;
  // Avoid duplicate injection
  if (subMenu.some((item) => item.id === 'manage-agentic-identities')) return topLevel;

  const userMgmtIndex = subMenu.findIndex((item) => item.id === 'user-management');
  const insertIndex = userMgmtIndex === -1 ? subMenu.length : userMgmtIndex;
  let newSubMenu = [
    ...subMenu.slice(0, insertIndex),
    AGENT_MANAGEMENT_NAV,
    ...subMenu.slice(insertIndex),
  ];

  if (isAgentRequestEnabled) {
    newSubMenu = newSubMenu.map((item) =>
      item.id === 'my-access'
        ? { ...item, subMenu: [...(item.subMenu || []), ...MY_ACCESS_AGENT_NAV] }
        : item
    );
  }

  return topLevel.map((menu, i) => (i === homeIndex ? { ...menu, subMenu: newSubMenu } : menu));
}

export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';
export const UPDATE_MENU_FILTER = 'UPDATE_MENU_FILTER';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags) => (dispatch) => {
  dispatch(sideMenuLoading());
  const response = HttpService.get('/ECM/navigation/leftNav', { 'X-NOERRORMODAL': true });

  const { isEmergencyRolesUser, isIntegration, isIspmEnabled, isAgentRequestEnabled } =
    featureFlags;

  response.then((res) => {
    let sideMenu = [...res.topLevel];

    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }
    if (isIntegration) {
      sideMenu = removeMenuById(sideMenu, 'design');
    } else {
      sideMenu = removeMenuById(sideMenu, 'integrations');
    }

    // Inject "Manage Agentic Identities" parent with "Non-Human" submenu only when ISPM is enabled
    if (isIspmEnabled) {
      sideMenu = injectAgentManagementNav(sideMenu, {
        isAgentRequestEnabled,
      });
    }

    // Derive isJitaEnabled from the backend left nav response.
    // If the response contains 'jita-sessions' or 'jit-access', the user is a JITA user.
    const hasJitaNavItem = res.topLevel.some(
      (menu) => menu.id === 'jit-access' || menu.subMenu?.some((sub) => sub.id === 'jita-sessions')
    );
    dispatch(setJitaEnabledAccount(hasJitaNavItem));

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  });
};

const updateMenuFilter = (menuId, isEnabled) => (dispatch, getState) => {
  const state = getState();
  const currentFilter = state.app?.menuFilters?.[menuId];
  const rawSideMenu = state.app?.rawSideMenu;

  // Only update if conditions are met
  if (rawSideMenu?.length && currentFilter !== isEnabled) {
    dispatch({
      type: UPDATE_MENU_FILTER,
      menuId,
      isEnabled,
    });
  }
};

export { InitializeSideMenu, updateMenuFilter };
